module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--euro-1b544f2eb8e47ab4e8f5c491e732d6b8.webp";